<div class="bg-th-blue mt-0 container-fluid py-2">
    <div class=" d-flex justify-content-between align-content-center">
        <i class="fa fa-arrow-left text-white my-auto pointer" (click)="goBack()"></i>
        <a class="text-white f18 my-auto dirI d-flex align-items-center"> {{bTransformation ? 'تحویل و تحول ها' : 'لیست
            سوختگیری ها' }}
            <i *ngIf="!bTransformation" class="fa fa-question-circle my-auto me-2 fa-2x pointer" (click)="guid(0)"></i>
        </a>
    </div>
</div>

<div class="table-responsive dirI rounded-3  my-1" id="print-table-fueldReport"
    style="max-height: 85vh; overflow-y: auto;">

    <div class="w-100 bg-th-blue position-sticky" style="bottom: 0; " *ngIf="refule?.length > 0 && !bTransformation">
        <div class="d-flex justify-content-around align-items-center flex-wrap dirI">
            <span class="text-white">تعداد کل : <strong>{{refule?.length | faNum}}</strong> مورد</span>
            <span class="text-white">جمع کل هزینه سوختگیری :
                <strong>{{otherService.getSeparatedValue(totalReview.totalCost) | faNum}}</strong> ریال</span>
            <span class="text-white">جمع کل لیتر سوختگیری : <strong>{{otherService.getSeparatedValue(totalReview.totalL)
                    | faNum}}</strong> لیتر</span>
            <div class="d-flex justify-content-center gap-2 align-items-center no-print">
                <button class="btn btn-success pointer no-print"
                    (click)="otherService.exportexcel( 'excel-table-fueldReport', 'گزارش سوختگیری.xlsx') "> خروجی اکسل
                    <i class="fa fa-file-excel-o"></i></button>
                <button printTitle="گزارش سوختگیری" printSectionId="print-table-fueldReport"
                    class="btn btn-secondary pointer no-print" [useExistingCss]="true" ngxPrint>چاپ <i
                        class="fa fa-print"></i></button>
            </div>
        </div>
    </div>

    <table class="table table-striped mt-1 dirI" id="excel-table-fueldReport">
        <thead class="">
            <tr class="text-center fw-bold">
                <!-- لیست سوختگیری ها  -->
                <ng-container *ngIf="!bTransformation">
                    <th scope="col" class="">#</th>
                    <th scope="col" class=""> عملیات </th>
                    <th scope="col" class=""> کاربر ثبت کننده </th>
                    <th scope="col" class="">تاریخ</th>
                    <th scope="col" class="">مبلغ (ریال)</th>
                    <th scope="col" class="">لیتر</th>
                    <th scope="col" class="">کیلومتر</th>
                </ng-container>

                <!-- لیست تحویل و تحول ها  -->
                <ng-container *ngIf="bTransformation">
                    <th scope="col" class="">#</th>
                    <th scope="col" class=""> عملیات </th>
                    <th scope="col" class=""> تحویل دهنده </th>
                    <th scope="col" class=""> تحویل گیرنده </th>
                    <th scope="col" class=""> تاریخ ثبت </th>
                    <th scope="col" class=""> وضعیت </th>
                </ng-container>
            </tr>
        </thead>
        <tbody>
            <!-- لیست سوختگیری ها  -->
            <ng-container *ngIf="!bTransformation">

                <tr class="text-center hoverMenu pointer f14" *ngFor="let item of refule;let i=index">

                    <th class="text-dark">{{i+1 | faNum}}</th>

                    <th class="text-dark">

                        <i class="fa fa-eye mx-2 fa-lg pointer" title="مشاهده" (click)="getSingel(i)"
                            aria-hidden="true"></i>

                        <i class="fa fa-file-image-o fa-lg pointer" title="فاکتور" (click)="showFactor(item)"
                            aria-hidden="true"></i>

                    </th>

                    <th class="text-dark">{{item.strUserSaved | faNum}}</th>

                    <th class="text-dark">{{item.strDate | faNum}}</th>

                    <th class="text-dark">{{item.iCost.toLocaleString() | faNum}}</th>

                    <th class="text-dark">{{item.fLiter | faNum}}</th>

                    <th class="text-dark">{{otherService.getSeparatedValue(item.iKm)}}</th>

                </tr>

            </ng-container>

            <!-- لیست تحویل و تحول ها  -->
            <ng-container *ngIf="bTransformation">

                <tr class="text-center hoverMenu f14" *ngFor="let item of list_Transformation;let i=index">

                    <th class="text-dark">{{ i + 1 | faNum}}</th>

                    <td class="text-dark">

                        <i class="fa fa-eye mx-2 fa-lg pointer" title="مشاهده"
                            (click)="openEditModal(item,i,'showMode')"></i>

                        <i *ngIf="item.tiStatus == 0" class="fa fa-trash text-danger mx-2 fa-lg pointer" title="حذف"
                            (click)="removeTransportation(item,i)"></i>

                        <i *ngIf="item.tiStatus == 0" class="fa fa-pencil text-primary mx-2 fa-lg pointer"
                            title="ویرایش" (click)="openEditModal(item,i)"></i>

                        <ng-container *ngIf="item.tiStatus == 1">

                            <i (click)="openModal_Operation(item,i)" class="fa fa-picture-o fa-lg pointer"
                                title="تصاویر" aria-hidden="true"></i>

                        </ng-container>

                        <i (click)="openList_Modal(item,i)" class="fa fa fa-list-alt mx-2 fa-lg pointer"
                            title="لیست اقلام تحویل شده " aria-hidden="true"></i>

                        <i *ngIf="item.tiStatus == 0" (click)="openModal_Operation(item,i)"
                            class="fa fa-check mx-2 fa-lg pointer" title="تائید نهایی" aria-hidden="true"></i>

                    </td>

                    <td class="text-dark">{{item.strDelivery_FullName | faNum}} <br> ( {{item.strDelivery_Mobile |
                        faNum}} ) </td>

                    <td class="text-dark">{{item.strTransferee_FullName | faNum}} <br> ( {{item.strTransferee_Mobile |
                        faNum}} ) </td>

                    <td class="text-dark"> {{item.strDate | faNum}} <br> ( {{item.strTime | faNum}} ) </td>

                    <td class="text-dark">{{item.strStatus | faNum}}</td>

                </tr>

            </ng-container>
        </tbody>

    </table>

</div>

<!-- Button trigger modal -->

<button type="button" class="btn btn-primary btn-plus" data-bs-toggle="modal" data-bs-target="#exampleModal"
    (click)="open()">

    <i class="fa fa-plus fa-2x"></i>

</button>

<!-- Modal -->

<div class="modal fade rtl " id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title" id="exampleModalLabel" *ngIf="!EditeMod"> {{bTransformation ? ' ثبت ' : ' ثبت
                    سوختگیری ' }}</h5>

                <h5 class="modal-title" id="exampleModalLabel" *ngIf="EditeMod"> {{EditeMod ? ' ویرایش ' : ' ویرایش
                    سوختگیری ' }}</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body ">

                <!-- ثبت سوختگیری -->
                <ng-container *ngIf="!bTransformation">
                    <form [formGroup]="sabtModel" class="d-flex flex-wrap justify-content-end">

                        <div class="col-md-5 col-11 mx-auto mt-2">
                            <label class="mb-2">تاریخ *</label>
                            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                                [dateGregorianFormat]="'YYYY/MM/DD'" [dateInitValue]="true"
                                [dateFormat]="'jYYYY/jMM/jDD'">
                                <input readonly formControlName="strDate" class="form-control text-end" />
                            </ng-persian-datepicker>
                        </div>

                        <div class="col-md-5 col-11 mx-auto mt-2">
                            <label class="mb-2">هزینه (ریال) *</label>
                            <input type="text" class="form-control text-end" formControlName="iCost"
                                (keypress)="seprator($event)" />
                        </div>

                        <div class="col-md-5 col-11 mx-auto mt-2">
                            <label class="mb-2">کیلومتر فعلی</label>
                            <input type="text" class="form-control text-end" formControlName="iKm"
                                (keypress)="seprator($event)" />
                        </div>

                        <div class="col-md-5 col-11 mx-auto mt-2">
                            <label class="mb-2">مقدار سوخت‌گیری (لیتر) *</label>
                            <input type="text" class="form-control text-end" formControlName="fLiter"
                                (keypress)="seprator($event)" />
                        </div>

                        <div class="col-md-5 col-11 mx-auto mt-2">
                            <label class="mb-2">کد جایگاه </label>
                            <input type="text" class="form-control text-end" formControlName="strLocationCode" />
                        </div>

                        <div class="col-11 mx-auto mt-2">
                            <button class="btn btn-primary" (click)="fileInput.click()">آپلود تصویر فاکتور</button>
                            <input hidden type="file" #fileInput (change)="onFileInput($event.target.files[0])" />
                        </div>

                        <div *ngIf="sabtModel.value.strImage" class="col-11 mx-auto mt-2">
                            <label class="mb-2"> تصویر فاکتور </label>
                            <input *ngIf="sabtModel.value.strImage == null || sabtModel.value.strImage == '' "
                                type="text" class="form-control" (click)="fileInput.click()">
                            <input hidden type="file" #fileInput (change)="onFileInput($event.target.files[0])" />
                            <img class="border border-2 rounded p-2 pointer"
                                *ngIf="sabtModel.value.strImage != null && sabtModel.value.strImage != ''" width="100%"
                                style="max-height: 360px;object-fit: cover;"
                                src="data:image/jpeg;base64,{{sabtModel.value.strImage}}" (click)="fileInput.click()"
                                alt="">
                        </div>

                        <div class="col-11 mx-auto">
                            <label class="mb-2 text-muted"> توضیحات </label>
                            <textarea formControlName="strComment" style="height: 100px;resize: none;"
                                class="form-control"></textarea>
                        </div>

                    </form>

                </ng-container>

                <!-- ثبت تحویل و تحول -->

                <ng-container *ngIf="bTransformation">

                    <form [formGroup]="transformationModel" class="row gx-2 gy-3 px-2 ">

                        <!-- تحویل دهنده -->

                        <div class="row gx-2 gy-3 px-2 pb-3 col-12 position-relative border border-2 rounded">

                            <span class="header-container"> تحویل دهنده </span>

                            <div class="col-md-6 col-12" style="pointer-events: none;">

                                <label for="strName" class="text-danger"> <small> نام راننده </small> </label>

                                <input type="text" formControlName="strDelivery_FullName" required class="form-control">

                            </div>

                            <div class="col-md-6 col-12" style="pointer-events: none;">

                                <label for="strName" class="text-danger"> <small> موبایل راننده </small> </label>

                                <input type="text" formControlName="strDelivery_Mobile"
                                    oninput="this.value = this.value.replace(/[^0-9]/g,'')" required
                                    class="text-end form-control">

                            </div>

                        </div>

                        <!-- تحویل گیرنده  -->

                        <div class="row gx-2 gy-3 px-2 pb-3 col-12 position-relative border border-2 rounded">

                            <span class="header-container"> تحویل گیرنده </span>

                            <div class="col-md-6 col-12">

                                <label for="strTransferee_FullName" class="text-danger"> نام و نام خانوادگی </label>

                                <input type="text" formControlName="strTransferee_FullName" required
                                    class="form-control">

                            </div>

                            <div class="col-md-6 col-12">

                                <label for="strTransferee_Mobile" class="text-danger"> موبایل </label>

                                <input type="text" formControlName="strTransferee_Mobile"
                                    oninput="this.value = this.value.replace(/[^0-9]/g,'')" required
                                    class="text-end form-control">

                            </div>

                        </div>

                        <!-- وضعیت خودرو -->

                        <div class="row gx-2 gy-3 px-2 pb-3 col-12 position-relative border border-2 rounded">

                            <span class="header-container"> وضعیت خودرو </span>

                            <div class="col-12">

                                <label for="strGlassesCondition" class="text-danger"> وضعیت شیشه ها </label>

                                <input type="text" formControlName="strGlassesCondition" required class="form-control">

                            </div>

                            <div class="col-12">

                                <label for="strFrontCondition" class="text-danger"> وضعیت جلوی خودرو </label>

                                <input type="text" formControlName="strFrontCondition" required class="form-control">

                            </div>

                            <div class="col-12">

                                <label for="strBackCondition" class="text-danger"> وضعیت پشت خودرو </label>

                                <input type="text" formControlName="strBackCondition" required class="form-control">

                            </div>

                            <div class="col-12">

                                <label for="strRightCondition" class="text-danger"> وضعیت راست خودرو </label>

                                <input type="text" formControlName="strRightCondition" required class="form-control">

                            </div>

                            <div class="col-12">

                                <label for="strLeftCondition" class="text-danger"> وضعیت چپ خودرو </label>

                                <input type="text" formControlName="strLeftCondition" required class="form-control">

                            </div>

                            <div class="col-12">

                                <label for="strRoofCondition" class="text-danger"> وضعیت سقف خودرو </label>

                                <input type="text" formControlName="strRoofCondition" required class="form-control">

                            </div>

                            <div class="col-12">

                                <label for="strCabinCondition" class="text-danger"> وضعیت داخل کابین </label>

                                <input type="text" formControlName="strCabinCondition" required class="form-control">

                            </div>

                            <div class="col-12">

                                <label for="strName" class=""> لوازم خودرو </label>

                                <input type="text" formControlName="strSupplies" class="form-control">

                            </div>

                            <div class="col-12">

                                <label for="strDocuments" class=""> مدارک خودرو </label>

                                <input type="text" formControlName="strDocuments" class="form-control">

                            </div>

                            <div class="col-12">

                                <label for="strViolation" class=""> وضعیت خلافی خودرو </label>

                                <input type="text" formControlName="strViolation" class="form-control">

                            </div>

                            <div class="col-md-6 col-12">

                                <label for="iKM" class="text-danger"> کیلومتر فعلی </label>

                                <input type="text" formControlName="iKM"
                                    oninput="this.value = this.value.replace(/[^0-9]/g,'')" required
                                    class="text-end form-control">

                            </div>

                            <div class="col-md-6 col-12">

                                <label for="iFuel" class=""> مقدار سوخت موجود(لیتر) </label>

                                <input type="text" formControlName="iFuel"
                                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                    class="text-end form-control">

                            </div>

                            <div class="pt-3 d-flex align-items-center col-12">

                                <input type="checkbox" formControlName="bSpare" name="bSpare">

                                <span class="mx-2">زاپاس موجود</span>

                            </div>

                            <div class="signature-container p-2 col-md-6 col-12" data-bs-toggle="modal"
                                data-bs-target="#exampleModal_2" (click)="isDelivery=true;signaturePad.clear()">

                                <div class="h-100 text-center border border-2">

                                    <span class="text-danger">امضاء تحویل دهنده</span>

                                    <ng-container *ngIf="transformationModel?.get('strDelivery_Signature')?.value">

                                        <img class="w-100 h-100"
                                            src="{{'data:image/png;base64,' + transformationModel.get('strDelivery_Signature')?.value}}"
                                            alt="">

                                    </ng-container>

                                </div>

                            </div>

                            <div class="signature-container p-2 col-md-6 col-12 " data-bs-toggle="modal"
                                data-bs-target="#exampleModal_2" (click)="isDelivery=false;signaturePad.clear()">

                                <div class="h-100 text-center border border-2">

                                    <span class="text-danger">امضاء تحویل گیرنده</span>

                                    <ng-container *ngIf="transformationModel?.get('strTransferee_Signature')?.value">

                                        <img class="w-100 h-100"
                                            src="{{'data:image/png;base64,' + transformationModel.get('strTransferee_Signature')?.value}}"
                                            alt="">

                                    </ng-container>

                                </div>

                            </div>

                        </div>

                    </form>

                </ng-container>

            </div>

            <div dir="ltr" class="modal-footer">

                <ng-container *ngIf="bTransformation">

                    <button type="button" [ngClass]="EditeMod ? 'btn-primary' : 'btn-success' " class="btn px-5"
                        (click)="newTransformation()"> {{EditeMod ? 'ویرایش' : 'ثبت' }} </button>

                </ng-container>

                <ng-container *ngIf="!bTransformation">

                    <button type="button" class="btn btn-danger" (click)="deleteRefule()" *ngIf="EditeMod">حذف <i
                            class="fa fa-trash"></i></button>

                    <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal"
                        (click)="close()">بستن
                    </button>

                    <button type="button" class="btn btn-success" (click)="sabt()" *ngIf="!EditeMod">ذخیره </button>

                    <button type="button" class="btn btn-success" (click)="edit()" *ngIf="EditeMod">ویرایش</button>

                </ng-container>

            </div>

        </div>

    </div>

</div>

<!-- امضاء -->

<div class="modal fade rtl" id="exampleModal_2" tabindex="-1" aria-hidden="true" role="dialog">

    <div class="modal-dialog" role="document">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title" id="exampleModal_2"> امضاء {{ isDelivery ? 'تحویل دهنده' : 'تحویل گیرنده' }}
                </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <signature-pad #signature [options]="signaturePadOptions"
                    (drawEnd)="drawComplete(signature)"></signature-pad>

            </div>

            <div class="modal-footer">

                <button type="button" class="px-3 btn btn-danger" (click)="signaturePad.clear()"> پاک کردن </button>

                <button type="button" class="px-3 btn btn-primary" data-bs-toggle="modal"
                    data-bs-target="#exampleModal"> ذخیره </button>

            </div>

        </div>

    </div>

</div>

<!-- تائید نهایی و تصاویر -->

<div class="modal fade rtl" id="exampleModal_3" tabindex="-1" aria-hidden="true" role="dialog">

    <div class="modal-dialog modal-lg" role="document">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title" id="exampleModal_2"> {{ isTF_Confirmation ? ' تائید نهایی ' : ' تصاویر ' }}</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <ng-container>

                    <form [formGroup]="tf_ConfirmationModel" class="row gx-2 gy-3 px-2 pb-3 col-12">

                        <ng-container *ngIf="isTF_Confirmation">

                            <div class="col-md-6 col-12">

                                <label for="strName" class="text-danger"> کد تائید تحویل دهنده </label>

                                <input type="text" formControlName="iDelivery_OTP"
                                    oninput="this.value = this.value.replace(/[^0-9]/g,'')" required
                                    class="text-end form-control">

                            </div>

                            <div class="col-md-6 col-12">

                                <label for="strName" class="text-danger"> کد تائید تحویل گیرنده </label>

                                <input type="text" formControlName="iTransferee_OTP"
                                    oninput="this.value = this.value.replace(/[^0-9]/g,'')" required
                                    class="text-end form-control">

                            </div>

                        </ng-container>

                        <div class="signature-container p-2 col-md-6 col-12"
                            (click)="isTF_Confirmation? fileInput.click() : '' ;whichImage='strImage_Front'">

                            <div class="h-100 text-center border border-2">

                                <span> تصویر جلو </span>

                                <ng-container *ngIf="tf_ConfirmationModel?.get('strImage_Front')?.value">

                                    <img class="w-100 h-100"
                                        src="{{'data:image/png;base64,' + tf_ConfirmationModel.get('strImage_Front')?.value}}"
                                        alt="">

                                </ng-container>

                            </div>

                        </div>

                        <div class="signature-container p-2 col-md-6 col-12"
                            (click)="isTF_Confirmation? fileInput.click() : '' ;whichImage='strImage_Back'">

                            <div class="h-100 text-center border border-2">

                                <span> تصویر پشت </span>

                                <ng-container *ngIf="tf_ConfirmationModel?.get('strImage_Back')?.value">

                                    <img class="w-100 h-100"
                                        src="{{'data:image/png;base64,' + tf_ConfirmationModel.get('strImage_Back')?.value}}"
                                        alt="">

                                </ng-container>

                            </div>

                        </div>

                        <div class="signature-container p-2 col-md-6 col-12"
                            (click)="isTF_Confirmation? fileInput.click() : '' ;whichImage='strImage_Right'">

                            <div class="h-100 text-center border border-2">

                                <span> تصویر راست </span>

                                <ng-container *ngIf="tf_ConfirmationModel?.get('strImage_Right')?.value">

                                    <img class="w-100 h-100"
                                        src="{{'data:image/png;base64,' + tf_ConfirmationModel.get('strImage_Right')?.value}}"
                                        alt="">

                                </ng-container>

                            </div>

                        </div>

                        <div class="signature-container p-2 col-md-6 col-12"
                            (click)="isTF_Confirmation? fileInput.click() : '' ;whichImage='strImage_Left'">

                            <div class="h-100 text-center border border-2">

                                <span> تصویر چپ </span>

                                <ng-container *ngIf="tf_ConfirmationModel?.get('strImage_Left')?.value">

                                    <img class="w-100 h-100"
                                        src="{{'data:image/png;base64,' + tf_ConfirmationModel.get('strImage_Left')?.value}}"
                                        alt="">

                                </ng-container>

                            </div>

                        </div>

                        <div class="signature-container p-2 col-md-6 col-12"
                            (click)="isTF_Confirmation? fileInput.click() : '' ;whichImage='strImage_Cabin'">

                            <div class="h-100 text-center border border-2">

                                <span> تصویر داخل </span>

                                <ng-container *ngIf="tf_ConfirmationModel?.get('strImage_Cabin')?.value">

                                    <img class="w-100 h-100"
                                        src="{{'data:image/png;base64,' + tf_ConfirmationModel.get('strImage_Cabin')?.value}}"
                                        alt="">

                                </ng-container>

                            </div>

                        </div>

                        <input hidden type="file" #fileInput (change)="onFileInput($event.target.files[0])" />


                    </form>

                </ng-container>


            </div>

            <div *ngIf="isTF_Confirmation" class="modal-footer">

                <button type="button" class="px-3 btn btn-primary" (click)="submitConfirmation()"> تائید نهایی </button>

            </div>

        </div>

    </div>

</div>

<div class="modal fade" id="Equipment_Modal">

    <div class="modal-dialog modal-lg">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> لیست اقلام تحویل شده </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div class="p-2">

                    <div class="section border border-2 p-1" style="max-height:calc(100vh - 260px);overflow: auto;">

                        <div *ngIf="obj_Equipment.tiStatus == 0" class="py-2">

                            <button class="btn btn-primary" (click)="confirm_LastList()"> بارگذاری آخرین اقلام تحویل شده
                            </button>

                            <button class="mx-md-2 btn btn-success" (click)="openAddEquipment()">

                                افزودن

                            </button>

                        </div>

                        <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                            <thead>

                                <tr class="">

                                    <th class="text-center"> # </th>

                                    <th class="text-center"> عملیات </th>

                                    <th class="text-center"> عنوان </th>

                                    <th class="text-center"> مقدار </th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr class="col-12 text-center" *ngFor="let item of lst_Equipment;let i = index">

                                    <th> {{ i + 1 | faNum }} </th>

                                    <td class="pointer">

                                        <i class="fa fa-edit fa-lg text-primary" (click)="edit_Equipment(item,i)"
                                            title="ویرایش"></i>

                                        <i class="fa fa-trash fa-lg text-danger mx-2" (click)="remove_Equipment(item,i)"
                                            title="حذف"></i>

                                    </td>

                                    <td> {{ item.strTitle | faNum }} </td>

                                    <td> {{ item.strValue | faNum }} </td>

                            </tbody>

                        </table>

                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>